import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actionCreators } from "./redux/sagas/goalsSummary/goalsSummary";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ClosestToCompletion from "./smartComponents/closestToCompletion";
import LeastLikelyToSucceed from "./smartComponents/leastLikelyToSucceed";
import GoalsToWatch from "./smartComponents/goalsToWatch";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import { isModuleActive, getCurrentMonthAndYear } from "../../../utils/modules";
import LearnMore from "../../../components/learnMore/learnMore";

export class GoalsSummaryModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      showGoals: false,
      worstPerformingGoalShow: false
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "Goals")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }
    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      let state = configuratorStore.getState();
      if (isModuleActive(state.dashboardConfigurator.preferences, "Goals") & !this.state.initRequest) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({
          initRequest: true
        });
      }
    });

    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.fetchGoalsByDate({
            id: this.props.currentUser.organization_id,
            objectId: this.props.currentUser.current_object_id,
            locationId: this.props.currentUser.current_location_id,
            regionId: this.props.currentUser.current_region_id,
            date: currentDate
          });
        }
      }
    });
  }
  UNSAFE_componentWillReceiveProps() {
    if (this.props.goalsToWatch.length > 0) {
      this.setState({
        showGoals: true
      });
    }
    if (Object.keys(this.props.worstPerformingGoal).length !== 0 && this.props.worstPerformingGoal.constructor === Object) {
      this.setState({
        worstPerformingGoalShow: true
      });
    }
  }
  render() {
    return (
      <SectionToggle
        title={`Goals to Watch | ${getCurrentMonthAndYear(this.props.currentUser.calendarEndDate)}`}
        learnMore={<LearnMore {...learnMoreProps()} />}
        showCta={this.state.showGoals}
        ctaContent="View All Goals"
        ctaLink={this.props.currentUser.allGoalsUrl}
        customClass="goals-summary"
        height={400}
        isLoading={this.props.isLoading}
        content={
          this.state.showGoals ? (
            <div className="goals-summary-wrapper">
              <div className="goal-donut">
                <ClosestToCompletion />
              </div>
              {this.state.worstPerformingGoalShow ? (
                <div className="goal-donut">
                  <LeastLikelyToSucceed />
                </div>
              ) : (
                <div className="goal-donut" />
              )}
              <div className="goals-to-watch">
                <GoalsToWatch />
              </div>
            </div>
          ) : (
            <div>
              <p
                className="no-goals-active"
                style={{
                  textAlign: "center",
                  paddingTop: "11%",
                  fontSize: "22px",
                  color: "#6f7077"
                }}
              >
                You currently have no active goals, please set at least one goal.
                <br />
                <a style={{ left: "0", top: "13px" }} className="cta" href={this.props.currentUser.allGoalsUrl}>
                  Go to Goals Page
                </a>
              </p>
            </div>
          )
        }
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.goalsSummary.isLoading,
    userParams: state.goalsSummary.currentUser,
    goalsToWatch: state.goalsSummary.goalsToWatch,
    worstPerformingGoal: state.goalsSummary.worstPerformingGoal
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    fetchGoalsByDate: actionCreators.fetchGoalsByDate
  }
)(GoalsSummaryModule);

GoalsSummaryModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  fetchGoalsByDate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  goalsToWatch: PropTypes.array,
  worstPerformingGoal: PropTypes.object
};

const learnMoreProps = () => {
  return {
    learnMoreId: "goals_to_watch_module",
    title: "Goals to Watch",
    content: (
      <>
        This module shows an overview of the current months goals, MTD.
        <br />
        <br />
        <h3>Most Likely To Succeed</h3>
        The goal most likely to reach target based on currently monthly projections.
        <br />
        <br />
        <h3>Least Likely To Succeed</h3>
        The goal least likely to reach target based on currently monthly projections.
        <br />
        <br />
        <h3>Goals To Watch</h3>
        User defined list of goals to watch.
        <br />
        <br />
        NOTE: The dashboard date selector does not affect this module. It will always display the current months goals.
      </>
    )
  };
};
